import React from 'react';
import { Link } from 'react-router-dom';

export default function ProviderOnboardingCompletePage() {
  return (
    <div>
      <h2>Onboarding complete</h2>
      <p>
        Your provider onboarding flow is complete. Final approval, verification status,
        and go-live readiness can be surfaced here next.
      </p>

      <Link to="/provider/dashboard">Go to provider dashboard</Link>
    </div>
  );
}